import { selector } from "recoil"

import { proposalLocalState } from "~/containers/Proposal/state/proposal/proposal-state"

export const selectedLoanProductState = selector({
  key: `selectedLoanProduct`,
  get: ({ get }) => {
    const { selectedLoanProduct } = get(proposalLocalState)

    return selectedLoanProduct ?? null
  },
})
